import {cookies, RestDataSource} from "@intermesh/goui";
import {PortalConfig} from "../config.js";

export type HttpVerb = "GET" | "HEAD" | "POST" | "PUT" | "PATCH" | "DELETE" | "CONNECT" | "OPTIONS";

type UploadResponse = {
	id: string,
	size: number,
	type: string,
	name: string,
	file: File,
	subfolder: string | undefined
}

export class ServerApi {
	static headers: HeadersInit = {};

	static readonly baseUrl: string = PortalConfig.APIUrl;

	static readonly ds = new RestDataSource(PortalConfig.APIUrl, "IFW");

	static get defaultRequestOptions(): RequestInit {
		let headers = ServerApi.headers;
		Object.assign(headers, {
			"Content-Type": "application/json",
			"Accept-Language": sessionStorage.getItem("language") || "nl"
		});
		if (cookies.get("accessToken")) {
			Object.assign(headers, {
				"Authorization": "Token " + cookies.get("accessToken")
			});
		}
		return {
			method: "GET" as HttpVerb,
			headers: headers,
			mode: "same-origin"
		}
	}

	/**
	 * Retrieve a single entity, translate to RESTful READ action
	 * @param route
	 * @param id
	 * @param returnProperties
	 */
	static single(route: string, id: number | string, returnProperties = "*"): Promise<any> {
		const r = new RestDataSource(PortalConfig.APIUrl, "IFW");
		const options = ServerApi.defaultRequestOptions,
			url = ServerApi.url(route + "/" + id, {returnProperties: returnProperties});
		// return ServerApi.ds.doRequest(url, options);
		return r.doRequest(url, options);
	}

	/**
	 * Retrieve multiple entities by id AND ID ONLY
	 *
	 * @param route
	 * @param ids
	 */
	static get(route: string, ids: number[]): Promise<any> {
		let params = {
			q: [
				['where', {"id": ids}],
				['orderBy', {'id': 'ASC'}]
			]
		};
		let url = ServerApi.url(route, params);
		const options = ServerApi.defaultRequestOptions;
		return ServerApi.ds.read(ids, url, options);
	}

	static call(route: string, body = {}, method?: HttpVerb): Promise<any> {
		let options = ServerApi.defaultRequestOptions;
		options.method = method || "GET";
		if (options.method !== "GET") {
			options.body = JSON.stringify({data: body});
		}
		return ServerApi.ds.doRequest(route, options)
	}

	/**
	 * generate a URL with parameters
	 *
	 * @param route :string
	 * @param params :object
	 * @param includeBaseUrl :boolean
	 */
	static url(route: string, params?: object, includeBaseUrl = false): string {
		if (!route && !params) {
			return "";
		}

		let url = (includeBaseUrl ? ServerApi.baseUrl : "") + route;

		params = params || {};

		let amp = false;

		if (params) {
			for (let [key, value] of Object.entries(params)) {
				switch (typeof value) {
					case "string":
						break;
					case "boolean":

						value = value ? '1' : '0';
						break;

					default:
						value = JSON.stringify(value);
						break;
				}

				if (amp) {
					url += '&';
				} else {
					url += '?';
					amp = true;
				}

				url += key + "=" + encodeURIComponent(value);
			}
		}

		return url;

	}

	static thumbUrl(blobId: string, h: number, w: number, zoomCrop = false) {
		return ServerApi.url(ServerApi.baseUrl + "thumb/" + blobId, {w: w, h: h, zoomCrop: zoomCrop});
	}

	static scormUrl(blockId: number, languageId: number): string {
		return ServerApi.url(ServerApi.baseUrl + "elearning/content/" + blockId + "/" + languageId + "/", {});
	}

	static async upload(file: File): Promise<any> {
		const url = ServerApi.url("upload", {}, false);

		let options = ServerApi.defaultRequestOptions;
		options.method = "POST";
		options.mode = "same-origin";
		options.credentials = "include";

		const headers: HeadersInit = options.headers!;
		Object.assign(headers, {
			"X-File-Name": "UTF-8''" + encodeURIComponent(file.name),
			"Content-Type": file.type,
			"X-File-LastModified": Math.round(file['lastModified'] / 1000).toString()
		});
		options.headers = headers
		options.body = file;

		return ServerApi.ds.doRequest(url, options);

	}

}